<template>
    <Link
        type="button"
        class="btn btn-link text-decoration-none text-secondary"
        as="a"
    >
        {{ $t('button.back') }}
    </Link>
</template>

<script setup lang="ts">
import {Link} from "@inertiajs/vue3";
</script>

<style scoped>

</style>
